import React from 'react';

import { StringKeyValue } from '../actions/types';
import ErrorMessage from '../components/Messages/ErrorMessage';
import { ErrorReducer } from '../reducers/error';
import { errorNames, serviceError } from '../util/mappings/errorName';

interface Props {
    text: StringKeyValue;
    error: ErrorReducer;
}

const AppErrors = ({ text, error }: Props): JSX.Element => {
    const { errorMessage } = error;

    let title;
    let content;
    let link;
    let linkText;
    let infoBox;

    switch (errorMessage) {
        case errorNames.kyc_blocked_error:
            title = text.summaryTitleControl;
            content = [text.summaryTextControl1, text.summaryTextControl2];
            link = text.serviceErrorReturnLink;
            linkText = text.summaryReturnButtonControl;
            infoBox = text.summaryInfoBoxControl;
            break;
        case errorNames.noTaxPeriodAvailable:
            title = text.taxYearErrorHeader;
            content = [text.taxYearErrorText1, text.taxYearErrorText2];
            infoBox = text.taxYearErrorInfoBox;
            break;
        case errorNames.aaaSolitity:
            title = text.aaaSoliditetErrorHeader;
            content = [text.aaaSoliditetErrorText];
            link = text.aaaSoliditetErrorLink;
            linkText = text.aaaSoliditetErrorLinkText;
            infoBox = text.aaaSoliditetErrorInfoBox;
            break;
        case errorNames.aaaSoliditet:
            title = text.aaaSoliditetErrorHeader;
            content = [text.aaaSoliditetErrorText];
            link = text.aaaSoliditetErrorLink;
            linkText = text.aaaSoliditetErrorLinkText;
            infoBox = text.aaaSoliditetErrorInfoBox;
            break;
        case errorNames.dnumberCustomer:
            title = text.dNummerKundeHeader;
            content = [text.dNummerKundeText];
            linkText = text.dNummerKundeLinkText;
            link = text.dNummerKundeLink;
            infoBox = text.dNummerKundeInfoBox;
            break;
        case errorNames.mindreAarigKunde:
            title = text.mindreaarigKundeHeader;
            content = [text.mindreaarigKundeText];
            linkText = text.mindreaarigKundeLinkText;
            link = text.mindreaarigKundeLink;
            infoBox = text.mindreaarigKundeInfoBox;
            break;
        /* AgriCard */
        case errorNames.agriInvalidCustomer:
            title = text.agricardInvalidUserHeader;
            content = [text.agricardInvalidUserText1, text.agricardInvalidUserText2];
            infoBox = text.agricardInvalidUserInfoBox;
            break;
        case errorNames.agriInvalidCard:
            title = text.agricardInvalidUserHeader;
            content = [text.agricardInvalidUserText1, text.agricardInvalidUserText2];
            infoBox = text.agricardInvalidUserInfoBox;
            break;
        case errorNames.agriTokenParseFailed:
            title = text.agricardInvalidTokenHeader;
            content = [text.agricardInvalidTokenText1, text.agricardInvalidTokenText2];
            infoBox = text.agricardInvalidTokenInfoBox;
            break;
        case errorNames.agriTokenValidFailed:
            title = text.agricardExpiredTokenHeader;
            content = [text.agricardExpiredTokenText1, text.agricardExpiredTokenText2];
            infoBox = text.agricardExpiredTokenInfoBox;
            break;
        /* Generic / Service */
        case serviceError:
            title = text.serviceErrorHeader;
            content = [text.serviceErrorText1, text.serviceErrorText2];
            link = text.serviceErrorReturnLink;
            linkText = text.serviceErrorReturnButton;
            infoBox = text.serviceErrorInfoBox;
            break;
        default:
            title = text.genericErrorHeader;
            content = [text.genericErrorText1, text.genericErrorText2, text.genericErrorText3];
            link = text.genericErrorReturnLink;
            linkText = text.genericErrorReturnButton;
            infoBox = text.genericErrorInfoBox;
    }

    return <ErrorMessage title={title} textList={content} link={link} linkText={linkText} infoBox={infoBox} />;
};

export default AppErrors;
